import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { createAnOrder, deleteUserCart, getUserCart, resetState } from "../features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { getTokenFromLocalStorage } from "./commonData";

const PaymentSuccess = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const cartState = useSelector((state) => state?.auth?.cartProducts);
  const [cartProductState, setCartProductState] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [address, setAddress] = useState(null);

  // Decode address from URL
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const addressParam = query.get("address");
    if (addressParam) {
      try {
        const decodedAddress = JSON.parse(decodeURIComponent(addressParam));
        setAddress(decodedAddress);
        localStorage.setItem("address", JSON.stringify(decodedAddress)); // Optional: save for later use
      } catch (err) {
        console.error("Failed to parse address:", err);
      }
    }
  }, [location]);

  // Prepare cart products
  useEffect(() => {
    if (cartState?.length > 0) {
      const items = cartState.map((item) => ({
        product: item.productId._id,
        quantity: item.quantity,
        price: item.price,
      }));
      setCartProductState(items);
    }
  }, [cartState]);

  // Calculate total amount
  useEffect(() => {
    if (cartState?.length > 0) {
      const sum = cartState.reduce(
        (acc, item) => acc + item.quantity * item.price,
        0
      );
      setTotalAmount(sum);
    }
  }, [cartState]);

  // Create order when redirected back from Stripe
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const paymentIntentId = query.get("payment_intent");
    const redirectStatus = query.get("redirect_status");

    if (
      paymentIntentId &&
      cartProductState.length > 0 &&
      totalAmount > 0 &&
      address
    ) {
      dispatch(
        createAnOrder({
          totalPrice: totalAmount,
          totalPriceAfterDiscount: totalAmount, // adjust if discount logic exists
          orderItems: cartProductState,
          paymentInfoStrip: {
            payment_id: paymentIntentId,
            status: redirectStatus || "succeeded",
          },
          shippingInfo: address,
        })
      );
    }
  }, [location, cartProductState, totalAmount, address, dispatch]);
    const config2 = {
      headers: {
        Authorization: `Bearer ${
          getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
        }`,
        Accept: "application/json",
      },
    };
  
    useEffect(() => {
      dispatch(getUserCart(config2));
      dispatch(deleteUserCart(config2))
       localStorage.removeItem("address");
            dispatch(resetState());
    }, []);

  return <>
  <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <div className="card shadow-lg text-center p-5" style={{ maxWidth: '500px' }}>
        <div className="display-4 text-success mb-3">✅</div>
        <h2 className="fw-bold mb-3">Payment Successful!</h2>
        <p className="text-muted mb-4">
          Thank you for your purchase. Your order is being placed and will be processed shortly.
        </p>
        <a href="/" className="btn btn-success px-4">
          Back to Home
        </a>
      </div>
    </div>
  </>;
};

export default PaymentSuccess;
